<script>
export default {
    name: "TheatreNotes",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    props: {

        procedures: Array,
    },

    computed: {

        procedure() {
            if(!this.procedures.length || !this.$route.params.procedureId) return {};

            const procedures = this.procedures.filter(proc => proc.procedureID == this.$route.params.procedureId);
        
            return procedures.length ? procedures[0] : {};
        },
    },

    components: {

        "preoperative-notes-form": () => import('./tabs/PreoperationNotes.vue'),
        "anaesthetist-notes-form": () => import('./tabs/AnaesthetistNotes.vue'),
        "postoperation-notes-form": () => import('./tabs/PostoperativeNotes.vue'),
        "operation-notes-form": () => import('./tabs/OperationNotes.vue'),
        "personnel-form": () => import('./tabs/PersonnelForm.vue'),
        "operation-images-form": () => import('./tabs/OperationImages.vue'),
        "vitals-tab": () => import('./tabs/Vitals.vue'),
    },
}
</script>
<template>
<div class="w-full mt-1 max-w-none" v-if="$route.params.procedureId">
    <ul class="flex border-b-2 border-gray-500">
      <li class="-mb-px mr-1">
          <a @click.prevent="active=0" href="javascript:void(0)" 
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold 
                whitespace-no-wrap" 
            :class="active == 0 ? activeClass : inActiveClass">Preoperation Notes</a>
      </li>
      <li class="-mb-px mr-1">
          <a @click.prevent="active=3" href="javascript:void(0)" 
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold 
                whitespace-no-wrap" 
            :class="active == 3 ? activeClass : inActiveClass">Personnel</a>
      </li>
      <li class="-mb-px mr-1">
          <a @click.prevent="active=6" href="javascript:void(0)" 
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold 
            whitespace-no-wrap" 
            :class="active == 6 ? activeClass : inActiveClass">Vitals</a>
      </li>
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=1" 
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold 
                whitespace-no-wrap" 
            :class=" active == 1 ? activeClass : inActiveClass">Anaesthetist Notes</a>
      </li>
      <li class="-mb-px mr-1">
          <a @click.prevent="active=4" href="javascript:void(0)" 
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold 
                whitespace-no-wrap" 
            :class="active == 4 ? activeClass : inActiveClass">Operation Notes</a>
      </li>
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=2" 
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold 
                whitespace-no-wrap" 
            :class="active == 2 ? activeClass : inActiveClass">Post Operation Notes</a>
      </li>
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=5" 
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold 
                whitespace-no-wrap" 
            :class="active == 5 ? activeClass : inActiveClass">Operation Images</a>
      </li>
    </ul>
    <div class="w-full" v-if="active==0">
        <preoperative-notes-form :procedure="procedure" />
    </div>
    <div class="w-full" v-if="active==1">
        <anaesthetist-notes-form :procedure="procedure" />
    </div>
    
    <div class="w-full" v-if="active==2">
        <postoperation-notes-form :procedure="procedure" />
    </div>
    <div class="w-full" v-if="active==3">
        <personnel-form :procedure="procedure" />
    </div>
    <div class="w-full" v-if="active==4">
        <operation-notes-form :procedure="procedure" />
    </div>
    <div class="w-full" v-if="active==5">
        <operation-images-form :procedure="procedure" />
    </div>
    <div class="w-full" v-if="active==6">
        <vitals-tab></vitals-tab>
    </div>
</div>
</template>